import { Fingerprint } from "lucide-react";
import { Button } from "../ui/button";
import { Spinner } from "../ui/spinner";

interface PasskeyButtonProps {
  onClick: () => void;
  isLoading?: boolean;
  disabled?: boolean;
  label?: string;
  variant?: "default" | "outline";
}

/**
 * First-factor passkey entry point — "no password at all", as opposed to the
 * passkey used as a second factor after one.
 *
 * Outlined by default: it sits beside the SSO buttons above the credential
 * form, and that row is alternatives to the primary path, not competitors
 * with it.
 */
export function PasskeyButton({
  onClick,
  isLoading = false,
  disabled = false,
  label = "Sign in with a passkey",
  variant = "outline",
}: PasskeyButtonProps) {
  return (
    <Button
      type="button"
      variant={variant}
      className="w-full"
      onClick={onClick}
      disabled={disabled || isLoading}
    >
      {isLoading ? (
        <Spinner size="sm" />
      ) : (
        <Fingerprint aria-hidden="true" className="size-4" />
      )}
      <span>{label}</span>
    </Button>
  );
}
